// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { millisecondsToHours as fn } from "../millisecondsToHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const millisecondsToHours = convertToFP(fn, 1);

// Fallback for modularized imports:
export default millisecondsToHours;
